import { Database, Plug } from 'lucide-react';

/**
 * Shown when HCM features need an active Fusion connection (saved or env fallback).
 */
export default function ConnectionRequiredNotice({ onOpenConnections, compact = false }) {
  return (
    <div
      className={`rounded-xl border border-amber-700/50 bg-amber-950/40 text-amber-100 ${
        compact ? 'p-3 text-xs' : 'p-4 text-sm'
      }`}
    >
      <div className={`flex items-start gap-2 ${compact ? '' : 'gap-3'}`}>
        <Database className={`shrink-0 text-amber-400 ${compact ? 'mt-0.5 h-4 w-4' : 'mt-0.5 h-5 w-5'}`} />
        <div className="min-w-0 flex-1">
          <p className={`font-semibold text-amber-50 ${compact ? 'text-xs' : 'text-sm'}`}>
            Fusion pod not connected
          </p>
          <p className={`mt-1 text-amber-200/90 ${compact ? 'text-[11px] leading-snug' : 'text-sm'}`}>
            Add your Oracle HCM tenant under <strong>Connections</strong> (Admin → Connections, or Manage in the
            sidebar), then click <strong>Activate</strong>. SQL Studio, Ask Data, and Report Copilot use that active
            connection — not a hardcoded environment.
          </p>
          {onOpenConnections && (
            <button
              type="button"
              onClick={onOpenConnections}
              className={`mt-2 inline-flex items-center gap-1.5 rounded-lg bg-amber-700/80 px-3 py-1.5 font-medium text-white hover:bg-amber-600 ${
                compact ? 'text-[11px]' : 'text-xs'
              }`}
            >
              <Plug className="h-3.5 w-3.5" />
              Open Connections
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
